import React, { useRef } from 'react';
var VeltSidebarButtonUnreadIcon = function (props) {
    var defaultCondition = props.defaultCondition, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-sidebar-button-unread-icon", { ref: ref, "default-condition": [true, false].includes(defaultCondition) ? (defaultCondition ? 'true' : 'false') : undefined }, children));
};
export default VeltSidebarButtonUnreadIcon;
